



























































import { Component, Vue } from 'vue-property-decorator';
import Jobseeker from './Jobseeker.vue';
import Myreferrals from './Myreferrals.vue';
import { vxm } from './../store.vuex';
import { profileAccordions } from '@/components/Commons/profileAccordions';
import { defaultProfileAccordions } from '@/components/Commons/defaultProfileAccordions';
import {
  MY_PROFILE_SECTIONS_MAPPER,
  NEW_PROFILE_SECTION_KEY_MAPPER,
} from '@/models/configs/ProfileConstants';

declare var window: any;

@Component({
  name: 'MyprofileAccordian',
  components: {
    Jobseeker,
    Myreferrals,
  },
})
export default class MyprofileAccordian extends Vue {
  async mounted() {
    await vxm.users.updatedUserProfile();
  }
  get availableAccordions() {
    return vxm.jobs.BrandingInfo.PROFILE_ACCORDIONS || defaultProfileAccordions;
  }
  get profileAccordions() {
    if (profileAccordions && profileAccordions.skills) {
      //profileAccordions.skills.text = this.skillSectionTitle.toString();
    }
    return profileAccordions;
  }

  get UserProfileSections() {
    if (this.IsConfigJSONEnabled) {
      return vxm.configs.ClientConfigs.userProfileConfig.profileSections.map(
        (section) => {
          const sectionKey =
            MY_PROFILE_SECTIONS_MAPPER[section.sectionKey] ||
            section.sectionKey.toLowerCase();
          const profileAccordion = this.profileAccordions[sectionKey];
          return {
            sectionKey,
            text: this.getProfileAccordionTitle(
              section.sectionKey.toLowerCase(),
              section.displayName,
            ),
            icon: section.iconKey + '.svg',
            routerView: profileAccordion.routerView,
            path: profileAccordion.path,
          };
        },
      );
    }
    return this.availableAccordions.map((sectionKey) => {
      const profileAccordion = this.profileAccordions[sectionKey];
      const normalizedSecionKey = NEW_PROFILE_SECTION_KEY_MAPPER[sectionKey]
        ? NEW_PROFILE_SECTION_KEY_MAPPER[sectionKey].toLowerCase()
        : sectionKey;
      profileAccordion.sectionKey = sectionKey;
      profileAccordion.text = this.getProfileAccordionTitle(
        normalizedSecionKey,
        profileAccordion.text,
      );
      return profileAccordion;
    });
  }

  get skillSectionTitle() {
    return vxm.configs.SkillSectionTitle || this.$t('skills.section.title');
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get IsConfigJSONEnabled() {
    return window.WorkLLama.isConfigJSONEnabled === 'true';
  }

  selectProfileMenuNew(value) {
    this.$router.push({ path: `/myprofile/v2/` + value });
  }

  getProfileAccordionTitle(key: string, defaultValue: string) {
    const label = this.$t(`profile-accordion.${key}`).toString();
    return label.indexOf('profile-accordion') >= 0 ? defaultValue : label;
  }
}
